<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i
      class="fa"
      [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
      style="margin-right: 10px; cursor: pointer;"
      (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body mdl-body" [hidden]="minimise">
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loading && displayTable) {
<div class="table-wrapper">
    <label>Maximum Loan Balance Question</label>
    <br />
    <br />
    <p class="info-text">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <b>To provide maximum balances of related party amounts loaned and borrowed for Form 5471 Schedule</b>
    </p>
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>Account Code</th>
          <th>Account Description</th>
          <th>PY Balance</th>
          <th>Trial Balance as Submitted</th>
          <th>Reclass Adjustments</th>
          <th>Net Amount per Trial Balance</th>
          <th>Maximum Balance during year, if different</th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th>(p)</th>
          <th>(a)</th>
          <th>(b)</th>
          <th>(c = a + b)</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (row of tableData; track $index) {
<tr>
          <td>{{ row.acc_code }}</td>
          <td>{{ row.acc_desc }}</td>
          <td class="right">{{ row.py_bal }}</td>
          <td class="right">{{ row.trialBal_submitted }}</td>
          <td class="right">{{ row.reclass_adjust }}</td>
          <td class="right">{{ row.net_amount }}</td>
          <td><input type="text" class="form-control right" [ngModel]="row.max_bal" (ngModelChange)="row.max_bal = $event" /></td>
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
